<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('definitionOfDiseases-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit LookUp definitionOfDiseases -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveDefinitionOfDiseases">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('code')"
                                          class="mr-2"
                                          v-model="definitionOfDiseases.code "
                                          :data-vv-as="$t('code')"
                                          v-validate="'max:500'"
                                          :error-messages="errors.collect('code ')"
                                          name="code "></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('subcode')"
                                          class="mr-2"
                                          v-model="definitionOfDiseases.subcode"
                                          :data-vv-as="$t('subcode')"
                                          v-validate="'max:50'"
                                          :error-messages="errors.collect('subcode ')"
                                          name="subcode "></v-text-field>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('disability-type')"
                                            :disabled="isDisabled"
                                            :error-messages="errors.collect( 'typeOfDisability')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="disabilityTypeList"
                                            :label="$t('disability-type')"
                                            :readonly="isDisabled"
                                            clearable
                                            item-value="code"
                                            name="typeOfDisability"
                                            @change="getsubDisabilityTypes($event);"
                                            v-model="definitionOfDiseases.typeOfDisability"></v-autocomplete>
                        </v-flex>
                        <v-flex md8 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('SUBdisability-type')"
                                            :disabled="isDisabled"
                                            :error-messages="errors.collect( 'typeOfDisability')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="disabilitySUBTypeList"
                                            :label="$t('SUBdisability-type')"
                                            :readonly="isDisabled"
                                            clearable
                                            item-value="code"
                                            name="subtypeOfDisability"
                                            v-model="definitionOfDiseases.subtypeofdisability"></v-autocomplete>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-textarea :label="$t('arabic-name')"
                                        class="mr-2"
                                        v-model="definitionOfDiseases.arName "
                                        :data-vv-as="$t('arabic-name')"
                                        v-validate="'max:500'"
                                        :error-messages="errors.collect('arName ')"
                                        name="arName "></v-textarea>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-textarea :label="$t('english-name')"
                                        class="mr-2"
                                        v-model="definitionOfDiseases.enName"
                                        :data-vv-as="$t('english-name')"
                                        v-validate="'max:500'"
                                        :error-messages="errors.collect('enName')"
                                        name="enName"></v-textarea>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-checkbox :label="$t('definition-Card')"
                                        v-model="definitionOfDiseases.definitionCard"
                                        :data-vv-as="$t('definition-Card')"
                                        :error-messages="errors.collect('definitionCard')"
                                        name="definitionCard"
                                        ref="definitionCard"></v-checkbox>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-checkbox :label="$t('isnew')"
                                        v-model="definitionOfDiseases.isnew"
                                        :data-vv-as="$t('isnew')"
                                        :error-messages="errors.collect('isnew')"
                                        name="isnew"
                                        ref="isnew"></v-checkbox>
                        </v-flex>

                        <v-flex md8 sm6 xs12>
                        </v-flex>
                        <v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>
                        <v-btn color="primary" :to="{ name: 'definitionOfDiseases-list' }">{{ $t('cancel') }}</v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>

    import DefinitionOfDiseasesService from "@/services/Disabilities/PersonWithDisabilities/DefinitionOfDiseasesService";
    import LookUpService from '@/services/LookUpService';

    export default {
        name: "definitionOfDiseases-details",
        data() {
            return {
                selected: [],
                // Filters
                definitionOfDiseases: {
                    id: 0,
                    arName: '',
                    enName: '',
                    definitionCard: false,
                    typeOfDisability: '',
                    subtypeofdisability: '',
                    code: '',
                },
                disabilityTypeList: [],
                disabilitySUBTypeList: [],
            };
        },
        async created() {
            await this.getDisabilityTypes();
            const definitionOfDiseasesId = this.$route.params.id;
            if (definitionOfDiseasesId) {
                /* add loading in edit mode */
                this.$store.dispatch("showLoading");
                const definitionOfDiseases = (await DefinitionOfDiseasesService.getDefinitionOfDiseases(definitionOfDiseasesId)).data;
                this.$store.dispatch("hideLoading");
                if (!definitionOfDiseases) this.$router.push({ name: "definitionOfDiseases-list" });
                this.definitionOfDiseases = { ...this.definitionOfDiseases, ...definitionOfDiseases };
                await this.getsubDisabilityTypes(this.definitionOfDiseases.typeOfDisability);
            }
        },

        methods: {
            /* save Operation */
            async saveDefinitionOfDiseases() {
                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch("showLoading");
                    const result = await DefinitionOfDiseasesService.saveDefinitionOfDiseases(this.definitionOfDiseases);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch("showMessage", { text: result.data.message });
                        this.$router.push({ name: "definitionOfDiseases-list" });
                    } else {
                        this.$store.dispatch("showMessage", { text: result.data.message, color: "error" });
                        this.$router.push({ name: "definitionOfDiseases-list", color: "error" });
                    }
                    this.$store.dispatch("hideLoading");
                }
            },
            async getDisabilityTypes() {
                this.disabilityTypeList = (await LookUpService.getLookup(112)).data;
            },
            async getsubDisabilityTypes(typeOfDisability) { 
                var typeindex = this.disabilityTypeList.findIndex(item => item.code === typeOfDisability.toString());              
                this.disabilitySUBTypeList = (await LookUpService.getLookupByParentId(this.disabilityTypeList[typeindex].id, 14525)).data;
            },
        },
    };
</script>
